import React, { useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap'; // Assuming you are using Bootstrap components
import { useTranslation } from 'react-i18next';
import SurveyQuestionnaires from '../../basic-component/SurveyQuestionnaires';
import { isArray } from 'util';
import { createMarkup } from '../../basic-component/CommonUtils';

export default function SurveyResponse(props) {
    debugger;
    const [message, setMessage] = useState(props?.props?.data?.successMsg);
    const [showMarks,setShowMarks]=useState(props?.props?.data?.score?.score);
    console.log(props);
    const { i18n, t } = useTranslation();
    const [showAnswers, setShowAnswers] = useState(false);
    const [surveyList, setSurveyList] = useState(props?.surveyData);
    const [answerList, setAnswerList] = useState(props?.props?.data.answerList.map((e) => {
        return { questionId: e.questionId, answerId: e.questionOptionId };
    }));
    const [correctAnswer, setCorrectAnswer] = useState(null);
    const [mode, setMode] = useState(1);


    useEffect(() => {
        if(props?.props?.data.secretMap != null){
       setCorrectAnswer(props?.props?.data.secretMap.map((e) => {
         return { questionid: e.questionId, answerid: e.id };}));
       }
        setShowMarks(props?.props?.data?.score?.score);
        setMessage(props?.props?.data?.successMsg);
        debugger;
        if (props?.props?.data?.showAnswersOnSubmit == true) {
          setShowAnswers(true);
           }
        else{
           setShowAnswers(false);
          }

    }, [props]);
    return (
        <Card className='survey-section' style={{
            background: 'rgba(0, 0, 0, 0.02)',
            backdropFilter: 'blur(10px)',
            padding: '20px',
            borderRadius: '12px',
            marginBottom: '20px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            color: 'black',
            border: '1px solid rgba(255, 255, 255, 0.3)',
        }}>           
         <Card.Header className='light-blue-bg fs-5 fw-medium px-4'>
                <Row>
                    <Col>
                        <div className="score-section" style={{
                            
                            }}>
                            {message}
                            {props?.props?.data?.isViewEndScore && (
                                <p style={{ fontSize: '1.5rem', color: '#005f75', fontWeight: 'bold' }}>
                                    Your score is: {showMarks}
                                </p>
                            )}
                        </div>
                     </Col>
                   
                </Row>
                {showAnswers == true && mode === 1 && <div style={{ borderBottom: '2px solid #ccc', marginBottom: '20px' }}></div>}
                {showAnswers == true && mode === 1 && <Row>
                    <Col>
                        <>
                            <div>
                                {
                                    isArray(surveyList) && surveyList?.map(categories => {
                                        return categories?.map(category => {
                                            return (<>
                                                {/* <Row>
                                                    <Col>
                                                        <div className={'survey-category-title-instructions'}
                                                            dangerouslySetInnerHTML={createMarkup(category.categoryName)}></div>
                                                    </Col>
                                                </Row> */}
                                                <SurveyQuestionnaires mode={1} questions={category.qSet} answerList={answerList} correct={correctAnswer} />
                                            </>)
                                        })
                                    })
                                }
                            </div>

                            <div style={{ marginTop: '2rem' , fontSize: '0.75rem', lineHeight: 1.2, fontWeight: 'normal', color: '#000', fontStyle: 'italic'}}>
                                     <div>
                                        *Correct Answer*: <span style={{ color: '#4CAF50' }}> Displayed in green</span>
                                    </div>
                                    <div>
                                        *Incorrect Answer*: <span style={{ color: '#F44336' }}> Displayed in red</span>
                                    </div>
                            </div>
                        </>
                    </Col>
                </Row>}
            </Card.Header>
        </Card>
    );
}

